import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { EmailLink } from '@src/common/EmailLink';

const StyledList = styled('ul', {
  listStyle: 'disc',
  listStylePosition: 'inside',
  fontSize: '20px',
  color: '$primary1',
  fontWeight: 600,
  marginBottom: '10px',
});

const StyledSpan = styled('span', {
  fontWeight: 'bold',
});

const StyledListItem = styled('li', {
  marginBottom: '5px',
});

export const AdminInfoList = ({
  adminFirstName,
  adminLastName,
  adminEmail,
  adminPhone,
  adminPhoneExt,
  isMaskInfo,
}) => {
  const maskName = (firstName, lastName) => {
    const lengthOfFirstName = firstName.trim().length;
    const name = `${firstName.substring(0, 1)}${Array(lengthOfFirstName).join(
      '#'
    )} ${lastName}`;
    return name;
  };
  const maskEmail = (email) => {
    const [beforeAt, afterAt] = email.split('@');
    const { length } = beforeAt;
    const numberOfNormalCharacters = Math.floor(length / 3);
    const numberOfMaskedCharacters = length - numberOfNormalCharacters;
    const maskedEmail = `${beforeAt.substring(
      0,
      numberOfNormalCharacters
    )}${Array(numberOfMaskedCharacters + 1).join('#')}@${afterAt}`;
    return maskedEmail;
  };
  const phoneFormatter = (number) => {
    const normalized = (number || '').replace(/[^\d]/g, '');

    if (normalized.length === 10) {
      if (isMaskInfo) {
        return normalized.replace(/(\d{3})(\d{3})(\d{4})/, '###-###-$3');
      }
      return normalized.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    }

    return number;
  };

  const name = isMaskInfo
    ? maskName(adminFirstName, adminLastName)
    : `${adminFirstName} ${adminLastName}`;
  const email = isMaskInfo ? maskEmail(adminEmail) : `${adminEmail}`;
  const emailSubject = 'Access to the UHC Provider Portal';
  const phone = phoneFormatter(adminPhone);

  return (
    <StyledList>
      <StyledListItem>
        Name: <StyledSpan>{name}</StyledSpan>
      </StyledListItem>
      <StyledListItem>
        Email:{' '}
        <StyledSpan>
          <Choose>
            <When condition={!isMaskInfo}>
              <EmailLink emailAddress={email} subject={emailSubject}>
                {email}
              </EmailLink>
            </When>
            <Otherwise>{email}</Otherwise>
          </Choose>
        </StyledSpan>
      </StyledListItem>
      <If condition={phone}>
        <StyledListItem>
          Phone:{' '}
          <StyledSpan>
            {phone}
            <If condition={adminPhoneExt}> Ext: {adminPhoneExt}</If>
          </StyledSpan>
        </StyledListItem>
      </If>
    </StyledList>
  );
};

AdminInfoList.propTypes = {
  adminFirstName: PropTypes.string,
  adminLastName: PropTypes.string,
  adminEmail: PropTypes.string,
  adminPhone: PropTypes.string,
  adminPhoneExt: PropTypes.string,
  isMaskInfo: PropTypes.bool,
};

AdminInfoList.defaultProps = {
  adminFirstName: '',
  adminLastName: '',
  adminEmail: '',
  adminPhone: '',
  adminPhoneExt: '',
  isMaskInfo: true,
};
